import FiguresTooltip from '../FiguresTooltip';

import { Tooltip } from 'antd';

const Paker = props => {
    const { research, scale, minDepth, title, date, width, toDepth } = props;

    const bottom = toDepth(research.bottom);
    const roof = toDepth(research.roof);

    return (
        <Tooltip
            title={<FiguresTooltip title={title} roof={roof} bottom={bottom} date={date} />}
            styles={{ root: { maxWidth: 'none' } }}
        >
            <svg
                width={width}
                height={(bottom - roof) * 16 + 16}
                fill="none"
                style={{
                    position: 'absolute',
                    left: 1,
                    transform: `translateY(${Math.abs((minDepth - research.roof) * scale - scale + 8)}px)`,
                }}
            >
                <path
                    d={`M8 ${((bottom - roof) * 16 + 16) / 2}L${width - 8} ${((bottom - roof) * 16 + 16) / 2}`}
                    stroke="#7E8DA9"
                />
                <path
                    d={`M${width - 3} ${((bottom - roof) * 16 + 16) / 2}L${width - 1} ${
                        ((bottom - roof) * 16 + 16) / 2
                    }`}
                    stroke="#7E8DA9"
                />
                <path
                    d={`M${width - 8.5} 0V${(bottom - roof) * 16 + 16}H${width - 9.5}V0H${width - 8.5}Z`}
                    fill="#7E8DA9"
                />
                <path
                    d={`M${width - 9} ${((bottom - roof) * 16 + 16 - (bottom - roof) * 16) / 2}H${width - 3}V${
                        (bottom - roof) * 16 + 8
                    }H${width - 9}`}
                    stroke="#7E8DA9"
                />
                <path
                    d={`M2 ${((bottom - roof) * 16 + 16) / 2}L0 ${((bottom - roof) * 16 + 16) / 2}`}
                    stroke="#7E8DA9"
                />
                <path d={`M7.5 0V${(bottom - roof) * 16 + 16}H8.5V0H7.5Z`} fill="#7E8DA9" />
                <path
                    d={`M8 ${((bottom - roof) * 16 + 16 - (bottom - roof) * 16) / 2}H2V${(bottom - roof) * 16 + 8}H8`}
                    stroke="#7E8DA9"
                />
            </svg>
        </Tooltip>
    );
};

export default Paker;
